import { authHeader } from '../helpers/auth-header';
import { config } from '../helpers/config';
import { commonServices } from './common.service';

export const SubscriptionServices = {
  createCustomer,
  confirmSubscription,
  getPublicKey
}

async function createCustomer(paymentMethod, cardholderEmail) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email: cardholderEmail,
      payment_method: paymentMethod
    })
  };

  return fetch(config.apiUrl + '/api/Subscriptions/CreateCustomer', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function confirmSubscription(subscriptionId) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify({
      subscriptionId: subscriptionId
    })
  };

  return fetch(config.apiUrl + '/api/Subscriptions/Subscription', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}

function getPublicKey() {
  const requestOptions = {
    method: 'GET',
    headers: { ...authHeader(), 'Content-Type': 'application/json' }
  };

  return fetch(config.apiUrl + '/api/Subscriptions/PublicKey', requestOptions).then(response => commonServices.handleResponse(response), error => commonServices.handleError(error));
}


// WEBPACK FOOTER //
// ./src/services/subscription.service.js